import { takeLatest } from 'redux-saga/effects'
import { EDIT_USER_SAGA } from 'src/store/types/adminData'
import editUser from './editUser'

export function* editUserSaga() {
  yield takeLatest(EDIT_USER_SAGA, editUser)
}
